import { parseAxiosException } from '@/helpers/exceptionParser.js'

export default ({ url, dataField, mapResponse }) => {
  if (!dataField && !mapResponse)
    console.error('fetchDataOnMount should get either dataField or mapResponse')
  if (mapResponse) {
    if (typeof mapResponse !== 'function') console.error('mapResponse must be a function') // todo: use babel plugin log
  }
  return {
    data() {
      return {
        isFetching: true,
        error: null,
        parsedException: null,
      }
    },
    async mounted() {
      try {
        const response = await this.$apiClient.get(url)
        if (mapResponse) {
          mapResponse(this, response)
        } else this[dataField] = response.data
      } catch (e) {
        const parsedException = parseAxiosException(e)
        this.$logError(`Error expected to originate from ${parsedException.origin}`)
        this.$logError(parsedException.data)
        this.error = e
        this.parsedException = parsedException
      }
      this.isFetching = false
    },
  }
}
